/**
 * שדות מחיר עם מפריד אלפים ("200,000").
 *
 * ה-state מחזיק תמיד את המספר הגולמי ("200000") — הפסיקים קיימים רק בתצוגה.
 * כך parseFloat, הערך שנשלח לשרת והערך שנשמר בהיסטוריה לא משתנים.
 *
 * שימוש:
 *   <input type="text" inputMode="numeric"
 *     value={formatThousands(price)}
 *     onChange={(e) => setPrice(toRawNumber(e.target.value))} />
 */

/**
 * מנקה קלט לערך גולמי: ספרות ונקודה עשרונית אחת, בלי פסיקים ובלי אפסים מובילים.
 * "2,000" → "2000" · "00150" → "150" · "185432.57" → "185432.57"
 */
export const toRawNumber = (value: string): string => {
  const [intPart = "", ...decimals] = value.replace(/[^\d.]/g, "").split(".");
  const cleanInt = intPart.replace(/^0+(?=\d)/, "");
  return decimals.length ? `${cleanInt}.${decimals.join("")}` : cleanInt;
};

/**
 * מוסיף מפריד אלפים לחלק השלם בלבד (לתצוגה).
 * "200000" → "200,000" · "185432.57" → "185,432.57"
 */
export const formatThousands = (raw: string): string => {
  const [intPart = "", decimals] = raw.split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimals === undefined ? grouped : `${grouped}.${decimals}`;
};
